module.exports = __webpack_public_path__ + "static/media/Steven-Mann-Resume-2022.ba3418ba.pdf";